import React from "react";

import { isBefore, subDays } from "date-fns";

export function usePaywallCheck(
	createdAt: string | null | undefined,
	hasAccessToHistory: boolean,
	historyLimitInDays: number | null,
): boolean {
	const paywallDate = React.useMemo(
		() => (hasAccessToHistory || !historyLimitInDays ? undefined : subDays(new Date(), historyLimitInDays)),
		[hasAccessToHistory, historyLimitInDays],
	);

	return React.useMemo(
		() => Boolean(paywallDate && createdAt && isBefore(createdAt, paywallDate)),
		[createdAt, paywallDate],
	);
}

export const MEETING_CARD_ELEMENT_ID = "meeting-card";
